module.exports = "/images/Icon.svg?ebaffd4a159983b56e952bbf3cdb2a49";